export class SharedComponentsUtil {
    stopByValidator(controls:any, validatorAlert: boolean, label: string){
        let validateError = null;
        if(controls != undefined){
          validateError = controls.errors;
        };
        let message = "";
        if(validatorAlert && validateError != null ){
          if(validateError.required != undefined){
            message = `El Campo ${label} es Requerido.`;
          }
          else if(validateError.minlength != undefined){
            message = `El Campo ${label} requiere ${validateError.minlength.requiredLength} caracteres minimo.`;
          }
          else if(validateError.maxlength != undefined){
            message = `El Campo ${label} requiere ${validateError.maxlength.requiredLength} caracteres maximo.`;
          }
          else if(validateError.pattern != undefined){
            message = `El Campo ${label} tiene formato incorrecto.`;
          }
          else if(validateError.customValidator != undefined){
            message = `${validateError.customValidator.message}`;
          }
    
          return {
            error: true,
            message: message
          };
        }else{
          return {
            error: false,
            message: "Sin errores"
          };
        }
      }
	
}